export const USER_DASHBOARD_PAGE_KEY = 'user-panel';
